export default __webpack_public_path__ + "static/media/Gruesome_2@2x.32e922f9.jpg";